let slider = null;
document.addEventListener("DOMContentLoaded", function () {
    new Swiper('.eggo-review-slider-new', {
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 12,
        breakpoints: {
            989: {
                slidesPerView: 3,
                slidesPerGroup: 3,
            },
            720: {
                slidesPerView: 2,
                slidesPerGroup: 2,
            },
            240: {
                slidesPerView: 1,
                slidesPerGroup: 1,
            }
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });
});
